// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Configure_configureContainer__lsqSL {
  animation: Configure_init__brTbr 0.5s;
  justify-content: center;
  width: 100%;
}

.Configure_configureContainer__lsqSL .Configure_title__XwYHk {
  justify-content: space-between;
  align-items: center;
}

.Configure_configureContainer__lsqSL .Configure_table__S-nhx {
  width: 100%;
  margin-bottom: 50px;
}

.Configure_configureContainer__lsqSL .Configure_table__S-nhx .Configure_paper__eNQs8 {
  width: 100%;
}

.Configure_configureContainer__lsqSL .Configure_table__S-nhx .Configure_tableContainer__N3Y1A {
  width: 100%;
  border-radius: 10px;
  max-height: 70vh;
  box-shadow: 0px 0px 15px -3px rgba(0, 0, 0, 0.268);
}

.Configure_configureContainer__lsqSL .Configure_table__S-nhx .Configure_tableContainer__N3Y1A .Configure_tableCellHeader__Bq1S4 {
  font-size: 0.9rem;
}

.Configure_configureContainer__lsqSL .Configure_table__S-nhx .Configure_tableCell__tpz8A {
  font-family: Roboto, sans-serif;
  font-size: 0.9rem;
  font-weight: 400;
  border-bottom: 1px solid rgba(0, 0, 0, 0.455);
}

.Configure_configureContainer__lsqSL .Configure_title__XwYHk {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-top: 30px;
  width: 100%;
  margin-bottom: 30px;
}

.Configure_configureContainer__lsqSL .Configure_title__XwYHk h1 {
  font-size: 1.5rem;
  font-family: Roboto, sans-serif;
  font-weight: 300;
  margin-left: 10px;
}

.Configure_noConfigs__qEKVI {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
}

.Configure_msg_container__HXVba {
  height: 25px;
  cursor: pointer;
}

@keyframes Configure_init__brTbr {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Pages/Configure/index.module.css"],"names":[],"mappings":"AAAA;EACE,qCAAoB;EACpB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,kDAAkD;AACpD;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,+BAA+B;EAC/B,iBAAiB;EACjB,gBAAgB;EAChB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF","sourcesContent":[".configureContainer {\n  animation: init 0.5s;\n  justify-content: center;\n  width: 100%;\n}\n\n.configureContainer .title {\n  justify-content: space-between;\n  align-items: center;\n}\n\n.configureContainer .table {\n  width: 100%;\n  margin-bottom: 50px;\n}\n\n.configureContainer .table .paper {\n  width: 100%;\n}\n\n.configureContainer .table .tableContainer {\n  width: 100%;\n  border-radius: 10px;\n  max-height: 70vh;\n  box-shadow: 0px 0px 15px -3px rgba(0, 0, 0, 0.268);\n}\n\n.configureContainer .table .tableContainer .tableCellHeader {\n  font-size: 0.9rem;\n}\n\n.configureContainer .table .tableCell {\n  font-family: Roboto, sans-serif;\n  font-size: 0.9rem;\n  font-weight: 400;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.455);\n}\n\n.configureContainer .title {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  margin-top: 30px;\n  width: 100%;\n  margin-bottom: 30px;\n}\n\n.configureContainer .title h1 {\n  font-size: 1.5rem;\n  font-family: Roboto, sans-serif;\n  font-weight: 300;\n  margin-left: 10px;\n}\n\n.noConfigs {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-top: 20px;\n}\n\n.msg_container {\n  height: 25px;\n  cursor: pointer;\n}\n\n@keyframes init {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"configureContainer": `Configure_configureContainer__lsqSL`,
	"init": `Configure_init__brTbr`,
	"title": `Configure_title__XwYHk`,
	"table": `Configure_table__S-nhx`,
	"paper": `Configure_paper__eNQs8`,
	"tableContainer": `Configure_tableContainer__N3Y1A`,
	"tableCellHeader": `Configure_tableCellHeader__Bq1S4`,
	"tableCell": `Configure_tableCell__tpz8A`,
	"noConfigs": `Configure_noConfigs__qEKVI`,
	"msg_container": `Configure_msg_container__HXVba`
};
export default ___CSS_LOADER_EXPORT___;
